module.exports = __webpack_public_path__ + "img/city-max.e8ad0cf5.png";